import { useAppSelector } from '../hooks'

export const useCabinetInfo = () => useAppSelector((state) => state.cabinet)
